import MachinesList from "./../../pages/MachinesList/MachinesList";
import { Alert, Box, LinearProgress, Typography } from "@mui/material";
import MachinesContext from "./../../context/MachinesContext";
import { useFetchIoTDevices } from '../../hooks/useFetchIoTDevices';
import { Fragment } from "react";
import { hasReadAllShadows, hasReadShadow } from '../../services/machines/machinesApi'
import { Shadow } from '../../types/Shadow.types'

function LoadingStage({ label, percent, note }: { label: string; percent: number; note?: string }) {
	return (
		<Box sx={{ mb: 2 }}>
			<Typography variant="body2" color="text.secondary">
				{label}: {percent}%{note && `. ${note}`}
			</Typography>
			<LinearProgress variant="determinate" value={percent} aria-label={label} />
		</Box>
	)
}

const MachinesView = () => {
	const { machines, isLoading, error, setVisibleMachines } = useFetchIoTDevices();
	// Two stages, in the background loading order: instances (used by search), then last update times.
	const instancesRead = machines.filter((machine) => hasReadShadow(machine, Shadow.Datasyncd)).length
	const datesRead = machines.filter(hasReadAllShadows).length
	const loadingInstances = instancesRead < machines.length
	const loadingDates = !loadingInstances && datesRead < machines.length
	const percent = (count: number) => Math.floor((count / machines.length) * 100)

	return (
		<Box className="machinesView">
			{error && <Alert severity="error">{error}</Alert>}
			{loadingInstances && <LoadingStage label="Wczytywanie instancji" percent={percent(instancesRead)} />}
			{loadingDates && (
				<LoadingStage
					label="Wczytywanie dat ostatniej aktualizacji"
					percent={percent(datesRead)}
					note="Wyszukiwanie po instancji obejmuje już wszystkie maszyny"
				/>
			)}
			<MachinesContext.Provider value={{ machines, isLoading, setVisibleMachines }}>
				<Fragment>
					<MachinesList />
				</Fragment>
			</MachinesContext.Provider>
		</Box>
	);
};

export default MachinesView;
